<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <b-container fluid>
      <div>
        <b-card header-tag="header">
          <template #header>
            <card-title>
              <b-icon class="icono" icon="file-text"></b-icon>Dashboard CDXE
            </card-title>
          </template>

          <b-card-body>
            <b-tabs content-class="mt-3">
              <b-tab title="PTI por nivel de complejidad">
                <b-row class="text-center" align-v="center">
                  <b-col sm="4">
                    <b-form-select
                      v-model="selectedMes"
                      :options="optionsMes"
                    ></b-form-select>
                  </b-col>
                  <b-col sm="4">
                    <b-form-select
                      v-model="selectedAnio"
                      :options="optionsAnio"
                    ></b-form-select>
                  </b-col>
                  <b-col sm="4">
                    <b-button v-if="$localStorageService.can('DX_11_consulta_pti_comp')"
                      v-on:click="
                        obtenerIndicadorNivel(selectedMes, selectedAnio)
                      "
                      class="entradasreporte botonesmargin"
                      variant="outline-primary"
                      >Ejecutar reporte</b-button
                    >
                  </b-col>
                </b-row>
                <b-row class="text-center" align-v="center">
                  <b-col sm="6">
                    <div id="ptisdoctores" class="esconderantes">
                      <b-table
                        striped
                        hover
                        :items="ptisdoctores"
                        :fields="ptiscolumnas"
                        thead-tr-class="columnas"
                      ></b-table>
                    </div>
                    <p id="totalptis" class="esconderantes">
                      Total PTI's: {{ totalPtis }}
                    </p>
                  </b-col>
                  <b-col sm="6">
                    <div class="margingraficas">
                      <canvas
                        id="ptinivel"
                        style="position: relative; display:block ;"
                      ></canvas>
                    </div>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Numero PTI's">
                <b-row class="text-center" align-v="center">
                  <b-col sm="4">
                    <b-form-select
                      v-model="selectedMes"
                      :options="optionsMes"
                      class="margeninputs"
                    ></b-form-select>
                  </b-col>
                  <b-col sm="4">
                    <b-form-select
                      v-model="selectedAnio"
                      :options="optionsAnio"
                      class="margeninputs"
                    ></b-form-select>
                  </b-col>
                  <b-col sm="4">
                    <b-button v-if="$localStorageService.can('DX_11_consulta_num_ptis')"
                      v-on:click="
                        generarIndicadoresNumeroPtis(selectedMes, selectedAnio)
                      "
                      class="entradasreporte margeninputs"
                      variant="outline-primary"
                      >Ejecutar reporte</b-button
                    >
                  </b-col>
                </b-row>
                <b-row
                  id="indicadorestextonumeroptis"
                  class="text-center margenindicadores esconderantes"
                  align-v="center"
                >
                  <b-col sm="6">
                    <p
                      id="totalptisfolios"
                      class="esconderantes indicadortexto"
                    >
                      Folios Totales: {{ foliosTotales }}
                    </p>
                  </b-col>
                  <b-col sm="6">
                    <ul id="listasdi" class="esconderantes indicadortexto">
                      <li
                        v-for="item in arrayTotalKits"
                        :key="item.kit"
                        style="list-style-type:none"
                      >
                        {{ "SDI " + item.kit + ": " + item.total + " " }}
                      </li>
                    </ul>
                  </b-col>
                </b-row>
                <b-row class="text-center" align-h="center" align-v="center">
                  <b-col sm="6">
                    <div class="margingraficas">
                      <canvas
                        id="numeroptis"
                        style="position: relative; display:block ;"
                      ></canvas>
                    </div>
                  </b-col>
                  <b-col sm="6">
                    <div class="margingraficas">
                      <canvas
                        id="tipoclinica"
                        style="position: relative; display:block ;"
                      ></canvas>
                    </div>
                  </b-col>
                </b-row>

                <b-row class="text-center" align-h="center">
                  <b-col sm="6">
                    <div class="margingraficas">
                      <canvas
                        id="kitsclinicaflex"
                        style="position: relative; display:block ;"
                      ></canvas>
                    </div>
                  </b-col>
                </b-row>

                <b-row class="text-center" align-h="center">
                  <b-col sm="6">
                    <div class="margingraficas">
                      <canvas
                        id="kitsclinicaconvencional"
                        style="position: relative; display:block ;"
                      ></canvas>
                    </div>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Tiempo de producción CDXE" >
                <b-row class="text-center" align-v="center" align-h="center">
                  <b-col sm="4">
                    <b-form-select
                      v-model="selectedMes"
                      :options="optionsMes"
                    ></b-form-select>
                  </b-col>
                  <b-col sm="4">
                    <b-form-select
                      v-model="selectedAnio"
                      :options="optionsAnio"
                    ></b-form-select>
                  </b-col>
                  <b-col sm="4">
                    <b-button v-if="$localStorageService.can('DX_11_consulta_tiempo_prod')"
                      v-on:click="
                        obtenerIndicadorTiempoProduccion(
                          selectedMes,
                          selectedAnio
                        )
                      "
                      class="entradasreporte botonesmargin"
                      variant="outline-primary"
                      >Ejecutar reporte</b-button
                    >
                  </b-col>
                </b-row>
                <b-row class="text-center" align-v="center" align-h="center">
                  <b-col sm="6">
                    <div class="margingraficastop">
                      <canvas
                        id="porcentajeslaflex"
                        style="position: relative; display:block ;"
                      ></canvas>
                    </div>
                  </b-col>
                  <b-col sm="6">
                    <div class="margingraficastop">
                      <canvas
                        id="porcentajeslaconvencional"
                        style="position: relative; display:block ;"
                      ></canvas>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="text-center" align-v="center" align-h="center">
                  <b-col sm="6">
                    <div class="margingraficastop customchart">
                      <canvas id="tiempoproduccionflex"></canvas>
                    </div>
                    <p id="indicadorflex" class="esconderantes">
                      Tiempo producción Flex: {{ tiempoproduccionflex }}
                    </p>
                  </b-col>
                  <b-col sm="6">
                    <div class="margingraficastop customchart">
                      <canvas
                        id="tiempoproduccionconvencional"
                        style="position: relative; display:block ;"
                      ></canvas>
                    </div>
                    <p id="indicadorconvencional" class="esconderantes">
                      Tiempo producción Convencional:
                      {{ tiempoproduccionconvencional }}
                    </p>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Numero de réplicas">
                <b-row class="text-center" align-v="center">
                  <b-col sm="4">
                    <b-form-select
                      v-model="selectedMes"
                      :options="optionsMes"
                    ></b-form-select>
                  </b-col>
                  <b-col sm="4">
                    <b-form-select
                      v-model="selectedAnio"
                      :options="optionsAnio"
                    ></b-form-select>
                  </b-col>
                  <b-col sm="4">
                    <b-button v-if="$localStorageService.can('DX_11_consulta_num_replicas')"
                      v-on:click="
                        obtenerNumeroReplicas(selectedMes, selectedAnio)
                      "
                      class="entradasreporte botonesmargin"
                      variant="outline-primary"
                      >Ejecutar reporter</b-button
                    >
                  </b-col>
                </b-row>
                <b-row class="text-center" align-h="center">
                  <b-col sm="8">
                    <div class="margingraficas">
                      <canvas
                        id="numeroreplicas"
                        style="position: relative;display:block ;"
                      ></canvas>
                    </div>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Errores de diagnostico" >
                <b-row class="text-center" align-v="center">
                  <b-col sm="4">
                    <b-form-select
                      v-model="selectedMes"
                      :options="optionsMes"
                    ></b-form-select>
                  </b-col>
                  <b-col sm="4">
                    <b-form-select
                      v-model="selectedAnio"
                      :options="optionsAnio"
                    ></b-form-select>
                  </b-col>
                  <b-col sm="4">
                    <b-button v-if="$localStorageService.can('DX_11_consulta_errores_diag')"
                      v-on:click="
                        obtenerIndicadorErroresDiagnostico(
                          selectedMes,
                          selectedAnio
                        )
                      "
                      class="entradasreporte botonesmargin"
                      variant="outline-primary"
                      >Ejecutar reporte</b-button
                    >
                  </b-col>
                </b-row>
                <b-row class="text-center">
                  <b-col sm="6">
                    <div class="margingraficas">
                      <canvas
                        id="errorendiagnostico"
                        style="position: relative;display:block ;"
                      ></canvas>
                    </div>
                  </b-col>
                  <b-col sm="6">
                    <div class="margingraficas">
                      <canvas
                        id="errorenespecialidad"
                        style="position: relative; display:block ;"
                      ></canvas>
                    </div>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Tiempo promedio de respuesta a replicas CDXE" >
                <b-row class="text-center" align-v="center">
                  <b-col sm="4">
                    <b-form-select
                      v-model="selectedMes"
                      :options="optionsMes"
                    ></b-form-select>
                  </b-col>
                  <b-col sm="4">
                    <b-form-select
                      v-model="selectedAnio"
                      :options="optionsAnio"
                    ></b-form-select>
                  </b-col>
                  <b-col sm="4">
                    <b-button v-if="$localStorageService.can('DX_11_consulta_tm_resp_rep')"
                      v-on:click="
                        obtenerIndicadorTiempoReplicas(
                          selectedMes,
                          selectedAnio
                        )
                      "
                      class="entradasreporte botonesmargin"
                      variant="outline-primary"
                      >Ejecutar reporte</b-button
                    >
                  </b-col>
                </b-row>
                <b-row class="text-center" align-v="center" align-h="center">
                  <b-col sm="6">
                    <div class="margingraficastop customchart">
                      <canvas id="porcentajereplicaflex"></canvas>
                    </div>
                  </b-col>
                  <b-col sm="6">
                    <div class="margingraficastop customchart">
                      <canvas
                        id="porcentajereplicaconvencional"
                        style="position: relative; display:block ;"
                      ></canvas>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="text-center" align-v="center" align-h="center">
                  <b-col sm="6">
                    <div class="margingraficastop customchart">
                      <canvas
                        id="tiempopromedioreplicaflex"
                        style="position: relative; display:block ;"
                      ></canvas>
                    </div>
                    <p id="indicadorreplicaflex" class="esconderantes">
                      Tiempo promedio replica Flex: {{ tiemporeplicaflex }}
                    </p>
                  </b-col>
                  <b-col sm="6">
                    <div class="margingraficastop customchart">
                      <canvas
                        id="tiempopromedioreplicaconvencional"
                        style="position: relative; display:block ;"
                      ></canvas>
                    </div>
                    <p id="indicadorreplicaconvencional" class="esconderantes">
                      Tiempo promedio replica Convencional:
                      {{ tiemporeplicaconvencional }}
                    </p>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
          </b-card-body>
        </b-card>
      </div>
    </b-container>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import Chart from "chart.js";
import graficaptinivel from "./graficaNivel";
import graficanumeroreplicas from "./graficaNumeroReplicas";
import graficanumeroptis from "./graficaNumeroPtis";
import graficatipoclinica from "./graficaTipoClinica";
import graficakitsclinicaflex from "./graficaKitsClinicaFlex";
import graficakitsclinicaconvencional from "./graficaKitsClinicaConvencional";
import graficatiempopromedioreplicas from "./graficaTiempoPromedioReplicas";
import graficaerrorenespecialidad from "./graficaErroresEspecialidad";
import graficaerrorendiagnostico from "./graficaErroresDiagnostico";
import graficatiempoproduccion from "./graficaTiempoProduccionFlex";
import graficatiempoproduccionconvencional from "./graficaTiempoProduccionFlex";
import graficaslaflex from "./graficaPorcentajeFlex";
import graficaslaconvencional from "./graficaPorcentajeConvencional";
import graficatiemporeplicaconvencional from "./graficaTiempoProduccionFlex";
import graficatiemporeplicaflex from "./graficaTiempoProduccionFlex";
import graficaslareplicaflex from "./graficaPorcentajeReplicaFlex";
import graficaslareplicaconvencional from "./graficaPorcentajeReplicaConvencional";
import Swal from "sweetalert2";

export default {
  components: {
    Header,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    contadorloading: 0,
    tiempoproduccionconvencional: 0,
    tiempoproduccionflex: 0,
    tiemporeplicaflex: 0,
    tiemporeplicaconvencional: 0,
    foliosTotales: 0,
    arrayTotalKits: [],
    totalPtis: 1000,
    objgraficakitsclinicaflex: null, //graficas barra flex
    objgraficakitsclinicaconvencional: null, //graficas barra convencional
    objgraficaptinivel: null, //graficas barra pti por nivle y doctor
    objgraficanumeroptis: null, //graficas numero totales ptis
    objgraficatipoclinica: null, //tipo clinica numero barras
    objgraficaerrorendiagnostico: null, //grafica dona por error de doctor
    objgraficaerrorenespecialidad: null, //grafica dona por error de especialidad
    objgraficatiempoproduccion: null,
    objgraficatiempoproduccionconvencional: null,
    objgraficatiempopromedioreplicas: null,
    objgraficaslaflex: null,
    objgraficaslaconvencional: null,
    objgraficatiemporeplicaflex: null,
    objgraficatiemporeplicaconvencional: null,
    objgraficaslareplicaflex: null,
    objgraficaslareplicaconvencional: null,
    optionsMes: [
      { value: 0, text: "Todo los meses" },
      { value: 1, text: "Enero" },
      { value: 2, text: "Febrero" },
      { value: 3, text: "Marzo" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Mayo" },
      { value: 6, text: "Junio" },
      { value: 7, text: "Julio" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Septiembre" },
      { value: 10, text: "Octubre" },
      { value: 11, text: "Noviembre" },
      { value: 12, text: "Diciembre" },
    ],
    optionsAnio: [
      { value: 2018, text: "2018" },
      { value: 2019, text: "2019" },
      { value: 2020, text: "2020" },
    ],
    selectedAnio: 2020,
    selectedMes: 0,
    graficaslaflex: graficaslaflex,
    graficatiempoproduccion: graficatiempoproduccion,
    graficatiempoproduccionconvencional: graficatiempoproduccionconvencional,
    graficaptinivel: graficaptinivel,
    graficaerrorendiagnostico: graficaerrorendiagnostico,
    graficanumeroreplicas: graficanumeroreplicas,
    graficanumeroptis: graficanumeroptis,
    graficatipoclinica: graficatipoclinica,
    graficakitsclinicaflex: graficakitsclinicaflex,
    graficakitsclinicaconvencional: graficakitsclinicaconvencional,
    graficatiempopromedioreplicas: graficatiempopromedioreplicas,
    graficaerrorenespecialidad: graficaerrorenespecialidad,
    graficaslaconvencional: graficaslaconvencional,
    graficatiemporeplicaflex: graficatiemporeplicaflex,
    graficatiemporeplicaconvencional: graficatiemporeplicaconvencional,
    graficaslareplicaflex: graficaslareplicaflex,
    graficaslareplicaconvencional: graficaslareplicaconvencional,
    ptisdoctores: [],
    backgroundColor: [
      "rgba(255,0,51,0.9)",
      "rgba(102,0,255,0.9)",
      "rgba(102,255,255,0.9)",
      "rgba(204,255,51,0.9)",
      "rgba(0,51,255,0.9)",
      "rgb(45, 136, 224)",
      "rgb(70, 150, 228)",
      "rgb(95, 164, 231)",
      "rgb(119, 178, 235)",
      "rgb(144, 192, 239)",
      "rgb(169, 206, 242)",
    ],
    borderColor: [
      "#36495d",
      "#36495d",
      "#36495d",
      "#36495d",
      "#36495d",
      "#36495d",
      "#36495d",
      "#36495d",
      "#36495d",
    ],
    ptiscolumnas: [
      {
        key: "nombre",
        label: "Diagnosticador",
        sortable: true,
      },
      {
        key: "niveli",
        label: "Nivel I",
        sortable: true,
      },
      {
        key: "nivelii",
        label: "Nivel II",
        sortable: true,
      },
      {
        key: "niveliii",
        label: "Nivel III",
        sortable: true,
      },
      {
        key: "niveliv",
        label: "Nivel IV",
        sortable: true,
      },
      {
        key: "total",
        label: "Total",
        sortable: true,
      },
    ],
  }),
  methods: {
    existePermiso(permiso) {
      return this.$localStorageService.can(permiso);
    },

    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      //Indicador PTI por nivel de complejidad
      if (chartId == "ptinivel") {
        this.objgraficaptinivel = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
        //Indicador Numero PTIS
      } else if (chartId == "numeroptis") {
        this.objgraficanumeroptis = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
        //Indicador Numero PTIS
      } else if (chartId == "tipoclinica") {
        this.objgraficatipoclinica = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
        //Indicador Numero PTIS
      } else if (chartId == "kitsclinicaflex") {
        this.objgraficakitsclinicaflex = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
        //Indicador Numero PTIS
      } else if (chartId == "kitsclinicaconvencional") {
        this.objgraficakitsclinicaconvencional = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
        //Error en diagnostico
      } else if (chartId == "errorendiagnostico") {
        this.objgraficaerrorendiagnostico = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
        //Error en especialidad
      } else if (chartId == "errorenespecialidad") {
        this.objgraficaerrorenespecialidad = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
        //Numero de replicas
      } else if (chartId == "numeroreplicas") {
        this.objgraficanumeroreplicas = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
        //Tiempo produccion flex
      } else if (chartId == "tiempoproduccionflex") {
        this.objgraficatiempoproduccion = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
        //Tiempo produccion convencional
      } else if (chartId == "tiempoproduccionconvencional") {
        this.objgraficatiempoproduccionconvencional = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
        //Tiempo promedio replicas
      } else if (chartId == "tiempopromedioreplicas") {
        this.objgraficatiempopromedioreplicas = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
        //Porcentaje sla flex
      } else if (chartId == "porcentajeslaflex") {
        this.objgraficaslaflex = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
        //Porcentaje sla conevencional
      } else if (chartId == "porcentajeslaconvencional") {
        this.objgraficaslaconvencional = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
        //Porcentaje replica flex
      } else if (chartId == "porcentajereplicaflex") {
        this.objgraficaslareplicaflex = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
        //Porcentaje replica convencional
      } else if (chartId == "porcentajereplicaconvencional") {
        this.objgraficaslareplicaconvencional = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
        //Velocimetro replica flex
      } else if (chartId == "tiempopromedioreplicaflex") {
        this.objgraficatiemporeplicaflex = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
        //Velocimetro replica convencional
      } else if (chartId == "tiempopromedioreplicaconvencional") {
        this.objgraficatiemporeplicaconvencional = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
      }
    },
    async obtenerIndicadorTiempoProduccion(mes, anio) {
      //Obtiene los indicadores de tiempo de produccion y porcentaje
      this.mostrarLoading();
      this.contadorloading = 0;
      let _this = this;
      try {
        this.objgraficaslaflex.destroy();
        this.objgraficatiempoproduccion.destroy();
        this.objgraficatiempoproduccionconvencional.destroy();
      } catch (error) {
        console.error(error);
      }
      const parametros = {
        anio: anio,
        mes: mes
      }
      await this.$http
        .post(
          this.$api +
            "indicadores/tiempoPromedioSdi", parametros
        )
        .then((response) => {
          if (response.data.data.listaTiempos.length == 0) {
            document.getElementById("tiempoproduccionflex").style.display =
              "none";
            document.getElementById(
              "tiempoproduccionconvencional"
            ).style.display = "NONE";
            document.getElementById("indicadorflex").style.display = "none";
            document.getElementById("indicadorconvencional").style.display =
              "none";
            document.getElementById("porcentajeslaflex").style.display = "none";
            document.getElementById("porcentajeslaconvencional").style.display =
              "none";
            Swal.fire("No hay información para este indicador");
            return false;
          } else {
            response.data.data.listaTiempos.forEach(function(value) {
              if (value.tipo == "FLEX") {
                _this.tiempoproduccionflex = value.tiempoPromedioHoras;
              }
              if (value.tipo == "CONVENCIONAL") {
                _this.tiempoproduccionconvencional = value.tiempoPromedioHoras;
              }
            });
            document.getElementById("tiempoproduccionflex").style.display =
              "block";
            document.getElementById(
              "tiempoproduccionconvencional"
            ).style.display = "block";
            document.getElementById("indicadorflex").style.display = "block";
            document.getElementById("indicadorconvencional").style.display =
              "block";
            document.getElementById("porcentajeslaflex").style.display =
              "block";
            document.getElementById("porcentajeslaconvencional").style.display =
              "block";
          }
          this.createChart(
            "tiempoproduccionflex",
            this.graficatiempoproduccion
          );
          this.createChart(
            "tiempoproduccionconvencional",
            this.graficatiempoproduccionconvencional
          );
          this.contadorloading++;
          Swal.close();
          return new Promise((resolve) => {
            resolve(this.contadorloading);
          });
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
          Swal.fire("No hay información para este indicador");
          this.contadorloading++;
          return new Promise((resolve) => {
            resolve(this.contadorloading);
          });
        });
      // porcentaje flex
      await this.$http
        .post(
          this.$api +
            "indicadores/cumplimientoSlaFlex", parametros
        )
        .then((response) => {
          this.graficaslaflex.data.datasets[0].data = [];
          if (response.data.data.porcentajeSiCumplieron != null) {
            this.graficaslaflex.data.datasets[0].data.push(
              response.data.data.porcentajeSiCumplieron.toFixed(2)
            );
            this.graficaslaflex.data.datasets[0].data.push(
              response.data.data.porcentajeNoCumplieron.toFixed(2)
            );
          }
          this.createChart("porcentajeslaflex", this.graficaslaflex);
          this.contadorloading++;
          return new Promise((resolve) => {
            resolve(this.contadorloading);
          });
        })
        .catch((error) => {
          console.error(error);
          this.contadorloading++;
          return new Promise((resolve) => {
            resolve(this.contadorloading);
          });
        });
      // porcentaje convencional produccion
      await this.$http
        .post(
          this.$api +
            "indicadores/cumplimientoSlaConvencional", parametros
        )
        .then((response) => {
          this.graficaslaconvencional.data.datasets[0].data = [];
          if (response.data.data.porcentajeSiCumplieron != null) {
            this.graficaslaconvencional.data.datasets[0].data.push(
              response.data.data.porcentajeSiCumplieron.toFixed(2)
            );
            this.graficaslaconvencional.data.datasets[0].data.push(
              response.data.data.porcentajeNoCumplieron.toFixed(2)
            );
          }
          this.createChart(
            "porcentajeslaconvencional",
            this.graficaslaconvencional
          );
          this.contadorloading++;
          return new Promise((resolve) => {
            resolve(this.contadorloading);
          });
        })
        .catch((error) => {
          console.error(error);
          this.contadorloading++;
          return new Promise((resolve) => {
            resolve(this.contadorloading);
          });
        });
      if (this.contadorloading === 3) {
        Swal.close();
      }
    },
    obtenerErroresDiagnosticoClinica(mes, anio) {
      //Indicador Errores de diagnostico
      return new Promise((resolve) => {
        let _this = this;
        let dataset = [];
        _this.graficaerrorenespecialidad.data.datasets = [];
        try {
          this.objgraficaerrorenespecialidad.destroy();
        } catch (error) {
          console.error(
            "Tratando de destruir grafica indicador nivel por especialidas"
          );
        }
        const parametros = {
          anio: anio,
          mes: mes
        }
        this.$http
          .post(
            this.$api +
              "indicadores/errorEspecialidad", parametros
          )
          .then((response) => {
            let arrayLabels = [];
            if (response.data.data.listaErroresDoctores.length == 0) {
              document.getElementById("errorendiagnostico").style.display =
                "none";
              document.getElementById("errorenespecialidad").style.display =
                "none";
              Swal.fire("No hay información para este indicador");
              return false;
            } else {
              response.data.data.listaErroresDoctores[0].listaErroresEspecialidades.forEach(
                function(value) {
                  arrayLabels.push(value.especialidad);
                }
              );
              response.data.data.listaErroresDoctores.forEach(function(value) {
                let dataErrores = [];
                value.listaErroresEspecialidades.forEach(function(value) {
                  dataErrores.push(value.numeroErrores);
                });
                dataset = {
                  label: value.abreviatura,
                  data: dataErrores,
                  backgroundColor: _this.backgroundColor,
                  borderColor: _this.borderColor,
                };
                _this.graficaerrorenespecialidad.data.datasets.push(dataset);
              });
              this.graficaerrorenespecialidad.data.labels = arrayLabels;
              this.createChart(
                "errorenespecialidad",
                this.graficaerrorenespecialidad
              );
              document.getElementById("errorendiagnostico").style.display =
                "block";
              document.getElementById("errorenespecialidad").style.display =
                "block";
            }
            this.contadorloading++;
            resolve(this.contadorloading);
          })
          .catch((error) => {
            console.error(error);
            document.getElementById("errorendiagnostico").style.display =
              "none";
            document.getElementById("errorenespecialidad").style.display =
              "none";
            Swal.fire("No hay información para este indicador");
            this.contadorloading++;
            resolve(this.contadorloading);
          });
      });
    },
    obtenerErroresDiagnostico(mes, anio) {
      return new Promise((resolve) => {
        //Indicador Errores de diagnostico
        try {
          this.objgraficaerrorendiagnostico.destroy();
        } catch (error) {
          console.error(error);
        }
        const parametros = {
          anio: anio,
          mes: mes
        }
        this.$http
          .post(
            this.$api +
              "indicadores/productividadError", parametros
          )
          .then((response) => {
            //arrayLables son las etiquetas de las graficas dataDoctores son los datos de la grafica
            let arrayLabels = [];
            let totalptis = [];
            let totalerrores = [];
            response.data.data.listaDoctores.forEach(function(value) {
              arrayLabels.push(value.abreviatura);
              totalptis.push(value.totalPti);
              totalerrores.push(value.totalErrores);
            });
            this.graficaerrorendiagnostico.data.labels = arrayLabels;
            this.graficaerrorendiagnostico.data.datasets[0].data = totalptis;
            this.graficaerrorendiagnostico.data.datasets[1].data = totalerrores;
            this.createChart(
              "errorendiagnostico",
              this.graficaerrorendiagnostico
            );
            this.contadorloading++;
            resolve(this.contadorloading);
          })
          .catch((error) => {
            console.error(error);
            this.contadorloading++;
            resolve(this.contadorloading);
          });
      });
    },
    async obtenerIndicadorErroresDiagnostico(mes, anio) {
      this.mostrarLoading();
      this.contadorloading = 0;
      await this.obtenerErroresDiagnostico(mes, anio);
      await this.obtenerErroresDiagnosticoClinica(mes, anio);
      if (this.contadorloading === 2) {
        Swal.close();
      }
    },
    obtenerIndicadorNivel(mes, anio) {
      //Obtener indicador menu PTI por nivel de complejidad
      this.mostrarLoading();
      try {
        this.objgraficaptinivel.destroy();
      } catch (error) {
        console.error(error);
      }
      const parametros = {
        anio: anio,
        mes: mes
      }
      this.$http
        .post(
          this.$api + "indicadores/productividad", parametros
        )
        .then((response) => {
          //arrayLables son las etiquetas de las graficas dataDoctores son los datos de la grafica
          let arrayLabels = [];
          let ptiDoctores = [];
          let dataDoctores = [];
          this.totalPtis = response.data.data.totalPti;
          response.data.data.listaProductividadDoctores.forEach(function(
            value
          ) {
            arrayLabels.push(value.abreviatura);
            dataDoctores.push(value.total);
            //Para la tabla informativa de los PTI de los doctores
            ptiDoctores.push({
              nombre: value.nombreDoctor,
              niveli: value.nivelI,
              nivelii: value.nivelII,
              niveliii: value.nivelIII,
              niveliv: value.nivelIV,
              total: value.total,
            });
          });
          this.graficaptinivel.data.labels = arrayLabels;
          this.graficaptinivel.data.datasets[0].data = dataDoctores;
          this.ptisdoctores = ptiDoctores;
          this.createChart("ptinivel", this.graficaptinivel);
          document.getElementById("totalptis").style.display = "block";
          document.getElementById("ptisdoctores").style.display = "block";
          Swal.close();
        })
        .catch((error) => {
          console.error(error);
          document.getElementById("totalptis").style.display = "none";
          document.getElementById("ptisdoctores").style.display = "none";
          Swal.close();
          Swal.fire("No hay información para este indicador");
        });
    },
    async generarIndicadoresNumeroPtis(mes, anio) {
      //Genera las graficas de Numero PTIs
      this.contadorloading = 0;
      this.mostrarLoading();
      this.arrayTotalKits = [];
      await this.obtenerNumeroPtis(mes, anio);
      await this.obtenerTipoClinica(mes, anio);
      await this.obtenerKitsClinicaTipo(mes, anio);
      if (this.contadorloading == 3) {
        Swal.close();
      }
    },
    obtenerNumeroPtis(mes, anio) {
      //Genera la primer grafica de numero PTIs indica el numero de tipo de KITS
      return new Promise((resolve) => {
        try {
          this.objgraficanumeroptis.destroy();
        } catch (error) {
          console.error("Tratando de destruir graficas... y con await");
        }
        let _this = this;
        const parametros = {
          anio: anio,
          mes: mes
        }
        this.$http
          .post(this.$api + "indicadores/tipoKit", parametros)
          .then((response) => {
            //arrayLabel etiquetas graficas y dataKits datos de grafica
            let arrayLabels = [];
            let dataKits = [];
            this.foliosTotales = response.data.data.total;
            if (response.data.data.listaKits.length == 0) {
              document.getElementById("numeroptis").style.display = "none";
              document.getElementById("totalptisfolios").style.display = "none";
              document.getElementById("listasdi").style.display = "none";
              document.getElementById("tipoclinica").style.display = "none";
              document.getElementById("kitsclinicaflex").style.display = "none";
              document.getElementById("kitsclinicaconvencional").style.display =
                "none";
              document.getElementById(
                "indicadorestextonumeroptis"
              ).style.display = "none";
              Swal.fire("No hay información para este indicador");
              return false;
            }
            response.data.data.listaKits.forEach(function(value) {
              _this.arrayTotalKits.push({
                kit: value.kit,
                total: value.numeroKits,
              });
              arrayLabels.push(value.kit);
              dataKits.push(value.numeroKits);
            });
            this.graficanumeroptis.data.labels = arrayLabels;
            this.graficanumeroptis.data.datasets[0].data = dataKits;
            this.createChart("numeroptis", this.graficanumeroptis);
            document.getElementById("numeroptis").style.display = "block";
            document.getElementById("totalptisfolios").style.display = "block";
            document.getElementById("listasdi").style.display = "block";
            document.getElementById(
              "indicadorestextonumeroptis"
            ).style.display = "flex";
            this.contadorloading++;
            resolve(this.contadorloading);
          })
          .catch((error) => {
            console.error(error);
            document.getElementById("numeroptis").style.display = "none";
            document.getElementById("totalptisfolios").style.display = "none";
            document.getElementById("listasdi").style.display = "none";
            Swal.fire("No hay información para este indicador");
            this.contadorloading++;
            resolve(this.contadorloading);
          });
      });
    },
    async obtenerIndicadorTiempoReplicas() {
      this.mostrarLoading();
      this.contadorloading = 0;
      //let _this = this;
      try {
        this.objgraficatiemporeplicaflex.destroy();
        this.objgraficatiemporeplicaconvencional.destroy();
      } catch (error) {
        console.error(error);
      }
      /*await this.$http
        .get(
          this.$api + "indicadores/replicasTiempo?anio=" + anio + "&mes=" + mes
        )
        .then((response) => {
          if (response.data.data.listaReplicaTiempo.length == 0) {
            try {
              document.getElementById("tiempopromedioreplicas").style.display =
                "none";
              Swal.fire("No hay información para este indicador");
              return false;
            } catch (error) {
              Swal.fire("No hay información para este indicador");
              return false;
            }
          } else {
            _this.tiemporeplicaflex = "No hay informacíon";
            _this.tiemporeplicaconvencional = "No hay informacíon";
            _this.graficatiempopromedioreplicas.data.datasets[0].data = [];
            response.data.data.listaReplicaTiempo.forEach(function(value) {
              if (value.tipoClinica == "FLEX") {
                _this.tiemporeplicaflex = value.tiempoPromedioHoras;
                _this.graficatiempopromedioreplicas.data.datasets[0].data.push(
                  value.promedio
                );
              }
              if (value.tipoClinica == "CONVENCIONAL") {
                _this.tiemporeplicaconvencional = value.tiempoPromedioHoras;
                _this.graficatiempopromedioreplicas.data.datasets[0].data.push(
                  value.promedio
                );
              }
            });
            document.getElementById("porcentajereplicaflex").style.display =
              "block";
            document.getElementById(
              "porcentajereplicaconvencional"
            ).style.display = "block";
            document.getElementById("tiempopromedioreplicaflex").style.display =
              "block";
            document.getElementById(
              "tiempopromedioreplicaconvencional"
            ).style.display = "block";
            document.getElementById("indicadorreplicaflex").style.display =
              "block";
            document.getElementById(
              "indicadorreplicaconvencional"
            ).style.display = "block";
            this.createChart(
              "tiempopromedioreplicaflex",
              this.graficatiemporeplicaflex
            );
            this.createChart(
              "tiempopromedioreplicaconvencional",
              this.graficatiemporeplicaconvencional
            );
          }
          this.contadorloading++;
          return new Promise((resolve) => {
            resolve(this.contadorloading);
          });
        })
        .catch((error) => {
          console.error(error);
          document.getElementById("porcentajereplicaflex").style.display =
            "none";
          document.getElementById(
            "porcentajereplicaconvencional"
          ).style.display = "none";
          document.getElementById("tiempopromedioreplicaflex").style.display =
            "none";
          document.getElementById(
            "tiempopromedioreplicaconvencional"
          ).style.display = "none";
          document.getElementById("indicadorreplicaflex").style.display =
            "none";
          document.getElementById(
            "indicadorreplicaconvencional"
          ).style.display = "none";
          this.contadorloading++;
          return new Promise((resolve) => {
            resolve(this.contadorloading);
          });
        });*/

      /*await this.$http
        .get(
          this.$api +
            "indicadores/cumplimientoReplicaFlex?anio=" +
            anio +
            "&mes=" +
            mes
        )
        .then((response) => {
          _this.graficaslareplicaflex.data.datasets[0].data = [];
          if (
            response.data.data.porcentajeSiCumplieron == "NaN" ||
            response.data.data.porcentajeNoCumplieron == "NaN"
          ) {
            document.getElementById("porcentajereplicaflex").style.display =
              "none";
            document.getElementById(
              "porcentajereplicaconvencional"
            ).style.display = "none";
            return false;
          }
          _this.graficaslareplicaflex.data.datasets[0].data.push(
            response.data.data.porcentajeSiCumplieron.toFixed(2)
          );
          _this.graficaslareplicaflex.data.datasets[0].data.push(
            response.data.data.porcentajeNoCumplieron.toFixed(2)
          );

          this.createChart("porcentajereplicaflex", this.graficaslareplicaflex);
          this.contadorloading++;
          return new Promise((resolve) => {
            resolve(this.contadorloading);
          });
        })
        .catch((error) => {
          console.error(error);
          document.getElementById("porcentajereplicaflex").style.display =
            "none";
          document.getElementById(
            "porcentajereplicaconvencional"
          ).style.display = "none";
          this.contadorloading++;
          return new Promise((resolve) => {
            resolve(this.contadorloading);
          });
        });*/

      /*await this.$http
        .get(
          this.$api +
            "indicadores/cumplimientoReplicaConvencional?anio=" +
            anio +
            "&mes=" +
            mes
        )
        .then((response) => {
          _this.graficaslareplicaconvencional.data.datasets[0].data = [];

          if (
            response.data.data.porcentajeSiCumplieron == "NaN" ||
            response.data.data.porcentajeNoCumplieron == "NaN"
          ) {
            document.getElementById("porcentajereplicaflex").style.display =
              "none";
            document.getElementById(
              "porcentajereplicaconvencional"
            ).style.display = "none";
            return false;
          }
          _this.graficaslareplicaconvencional.data.datasets[0].data.push(
            response.data.data.porcentajeSiCumplieron.toFixed(2)
          );
          _this.graficaslareplicaconvencional.data.datasets[0].data.push(
            response.data.data.porcentajeNoCumplieron.toFixed(2)
          );

          this.createChart(
            "porcentajereplicaconvencional",
            this.graficaslareplicaconvencional
          );
          this.contadorloading++;
          return new Promise((resolve) => {
            resolve(this.contadorloading);
          });
        })
        .catch((error) => {
          console.error(error);
          document.getElementById("porcentajereplicaflex").style.display =
            "none";
          document.getElementById(
            "porcentajereplicaconvencional"
          ).style.display = "none";
          document.getElementById("tiempopromedioreplicaflex").style.display =
            "none";
          document.getElementById(
            "tiempopromedioreplicaconvencional"
          ).style.display = "none";
          document.getElementById("indicadorreplicaflex").style.display =
            "none";
          document.getElementById(
            "indicadorreplicaconvencional"
          ).style.display = "none";
          this.contadorloading++;
          return new Promise((resolve) => {
            resolve(this.contadorloading);
          });
        });*/

      if (this.contadorloading === 3) {
        Swal.close();
      }
    },
    obtenerTipoClinica(mes, anio) {
      //Obtiene grafica horizontal que muestra el numero de kits por tipo de graficas
      return new Promise((resolve) => {
        try {
          this.objgraficatipoclinica.destroy();
        } catch (error) {
          console.error("Intendado destruir esta grafica");
        }
        const parametros = {
          anio: anio,
          mes: mes
        }
        this.$http
          .post(
            this.$api + "indicadores/clinicaKit", parametros
          )
          .then((response) => {
            //arrayLabel etiquetas graficas y dataKits datos de grafica
            let arrayLabels = [];
            let dataKits = [];
            if (response.data.data.listaClinica.length == 0) {
              document.getElementById("tipoclinica").style.display = "none";
              return false;
            }
            response.data.data.listaClinica.forEach(function(value) {
              arrayLabels.push(value.tipoClinica);
              dataKits.push(value.numeroKits);
            });
            this.graficatipoclinica.data.labels = arrayLabels;
            this.graficatipoclinica.data.datasets[0].data = dataKits;
            document.getElementById("tipoclinica").style.display = "block";
            this.createChart("tipoclinica", this.graficatipoclinica);
            this.contadorloading++;
            resolve(this.contadorloading);
          })
          .catch((error) => {
            console.error(error);
            document.getElementById("tipoclinica").style.display = "none";
            this.contadorloading++;
            resolve(this.contadorloading);
          });
      });
    },
    obtenerKitsClinicaTipo(mes, anio) {
      //Obtiene las graficas de KITS por clinica ya sea por SDI convencional o flex
      return new Promise((resolve) => {
        try {
          this.objgraficakitsclinicaflex.destroy();
          this.objgraficakitsclinicaconvencional.destroy();
        } catch (error) {
          console.error("tratando de destruir graficas");
        }

        const parametros = {
          anio: anio,
          mes: mes
        }
        this.$http
          .post(
            this.$api +
              "indicadores/clinicaKitEnviado", parametros
          )
          .then((response) => {
            let _this = this;
            let contadorflex = 0;
            let contadorconvencional = 0;
            response.data.data.listaTipoClinica.forEach(function(value) {
              if (value.tipoClinica == "FLEX") {
                contadorflex++;
                document.getElementById("kitsclinicaflex").style.display =
                  "block";
                let arrayLabels = [];
                let dataKits = [];
                value.listaClinicas.forEach(function(value) {
                  arrayLabels.push(value.nombreClinica);
                  dataKits.push(value.numeroKits);
                });
                _this.graficakitsclinicaflex.data.labels = arrayLabels;
                _this.graficakitsclinicaflex.data.datasets[0].data = dataKits;
                _this.createChart(
                  "kitsclinicaflex",
                  _this.graficakitsclinicaflex
                );
              } else if (value.tipoClinica == "CONVENCIONAL") {
                contadorconvencional++;
                let arrayLabels = [];
                let dataKits = [];
                value.listaClinicas.forEach(function(value) {
                  arrayLabels.push(value.nombreClinica);
                  dataKits.push(value.numeroKits);
                });
                _this.graficakitsclinicaconvencional.data.labels = arrayLabels;
                _this.graficakitsclinicaconvencional.data.datasets[0].data = dataKits;
                _this.createChart(
                  "kitsclinicaconvencional",
                  _this.graficakitsclinicaconvencional
                );
                document.getElementById(
                  "kitsclinicaconvencional"
                ).style.display = "block";
              }
            });
            if (contadorflex == 0) {
              document.getElementById("kitsclinicaflex").style.display = "none";
            }
            if (contadorconvencional == 0) {
              document.getElementById("kitsclinicaconvencional").style.display =
                "none";
            }
            this.contadorloading++;
            resolve(this.contadorloading);
          })
          .catch((error) => {
            console.error(error);
            document.getElementById("kitsclinicaflex").style.display = "none";
            document.getElementById("kitsclinicaconvencional").style.display =
              "none";
            this.contadorloading++;
            resolve(this.contadorloading);
          });
      });
    },
    obtenerNumeroReplicas() {
      //Genera la primer grafica de numero PTIs indica el numero de tipo de KITS
      // let _this = this;
      this.mostrarLoading();
      try {
        this.objgraficanumeroreplicas.destroy();
      } catch (error) {
        console.error("Tratando de destruir graficas numero de replicas...");
      }
      /*this.$http
        .get(this.$api + "indicadores/replicas?anio=" + anio + "&mes=" + mes)
        .then((response) => {
          //arrayLabel etiquetas graficas y dataKits datos de grafica
          let arrayLabels = [];
          let datasets = [];
          let datosreplicas = [];
          let datosproductividad = [];
          let datosporcentaje = [];
          let datacompleto = [];
          let dataset;
          if (response.data.data.listaDoctores.length == 0) {
            document.getElementById("numeroreplicas").style.display = "none";
            Swal.fire("No hay información para este indicador");
            return false;
          } else {
            document.getElementById("numeroreplicas").style.display = "block";
            response.data.data.listaDoctores.forEach(function(value) {
              arrayLabels.push(value.abreviatura);
              datosreplicas.push(value.replicas);
              datosproductividad.push(value.productividad);
              datosporcentaje.push(value.porcentajeReplicas.toFixed(2));
            });

            datasets.push(datosreplicas);
            datasets.push(datosproductividad);
            datasets.push(datosporcentaje);
            let labelEstatico = ["Replicas", "Productividad", "% Replicas"];
            let background = [
              "rgb(27, 107, 185)",
              "rgb(119, 178, 235)",
              "rgb(238, 209, 172)",
            ];
            let contadorLabel = 0;
            datasets.forEach(function(value) {
              dataset = {
                label: labelEstatico[contadorLabel],
                backgroundColor: background[contadorLabel],
                data: value,
              };
              datacompleto.push(dataset);
              contadorLabel++;
            });
            this.graficanumeroreplicas.data.datasets = datacompleto;
            this.graficanumeroreplicas.data.labels = arrayLabels;
            this.createChart("numeroreplicas", this.graficanumeroreplicas);
          }
          Swal.close();
        })
        .catch((error) => {
          Swal.close();
          console.error(error);
          document.getElementById("numeroreplicas").style.display = "none";
          Swal.fire("No hay información para este indicador");
        });*/
    },
    mostrarLoading() {
      Swal.fire({
        title: "Se esta ejecutando el reporte",
        html: "Espere por favor",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {
  },
  computed: {},
};
</script>

<style scoped>
.template {
  width: 100%;
}

.headerTxt {
  font-weight: bold;
}

.SearchPti {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.bolderTxt {
  font-size: 14px;
  font-weight: bolder;
  width: 20%;
  margin-left: 15px;
}

#patientSelect {
  padding-left: 25px;
  padding-right: 25px;
}
.entradasreporte {
  padding: 10px;
}
.labelderecha {
  margin-right: 15px;
  margin-top: 10px;
}
.muevecalendario {
  margin-top: 15px;
}
.botonesmargin {
  margin: 20px;
}
.margeninputs {
  margin: 10px;
  margin-bottom: 50px;
}
.margenindicadores {
  display: flex;
  border-style: solid;
  margin: 20px;
  border-radius: 20px;
  border-width: 0.1px;
  padding: 10px;
  border-color: gray;
}
.multipleselect {
  display: flex;
  align-items: flex-start;
}
.labelmultiselect {
  margin-top: 18px;
  margin-right: 15px;
}
.margingraficas {
  margin: 30px;
}
.margingraficastop {
  margin-top: 10px;
}
.esconderantes {
  display: none;
}
.indicadortexto {
  font-weight: 600;
}
ul {
  margin-top: 10px;
}
.customchart {
  max-width: 400px;
  max-height: 300px;
  margin: 0 auto;
}
</style>
